import { S3Client, PutObjectCommand } from '@aws-sdk/client-s3';



export class CdnUtils {
    client: S3Client;
    bucket: string = 'avron-quizzes';

    constructor() {
        this.client = new S3Client({
            region: 'auto',
            endpoint: `https://${process.env.REACT_APP_CF_ACCOUNT_ID!}.r2.cloudflarestorage.com`,
            credentials: {
                accessKeyId: process.env.REACT_APP_CF_KEY_ID!,
                secretAccessKey: process.env.REACT_APP_CF_SECRET_ACCESS_KEY!
            }
        });
    }

    async uploadFile(file: File) {
        const body = await file.arrayBuffer();
        const data = await this.client.send(new PutObjectCommand({
            Bucket: this.bucket,
            Key: file.name,
            Body: new Uint8Array(body),
            ContentType: file.type
        }));
        console.log("File uploaded", data);
        return `${process.env.REACT_APP_CF_R2_BUCKET_PUBLIC_LINK!}/${file.name}`;
    }
}